import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isAdmin, userHomePath } from '../support/accountFunction';

function AdminRoute({ children }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-slate-200 border-t-forge-600" />
      </div>
    );
  }

  if (!isAdmin(user)) {
    return <Navigate to={userHomePath()} replace />;
  }

  return children;
}

export default AdminRoute;
